"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasScopes = hasScopes;
const logger_1 = require("./logger");
/**
 * Check if the user has the required scopes to access the resource
 * @param adminScopes The scopes coming from the JWT
 * @param expectedScopes The scopes that are required to access the resource
 * @returns boolean indicating if the user has the required scopes
 */
function hasScopes(adminScopes, expectedScopes) {
    return expectedScopes.every((scope) => {
        if (adminScopes.length === 0) {
            return false;
        }
        const parts = scope.split(':');
        if (parts.length === 1) {
            logger_1.logger.warn({ scope }, 'Missing the scope action');
            return false;
        }
        const action = parts.pop();
        // This will join back and include the top- and any sub-level resources –
        // e.g. users:licenses
        const resource = parts.join(':');
        // If the action is 'read' then we should also check for mutation access eg:
        // teams.supervisingBroker:read is the required scope but the user need to
        // have teams.supervisingBroker:write to get read access
        if (action === 'read') {
            // If the user has mutation access to the resource, they should
            // have read access as well.
            return adminScopes.some((scp) => new RegExp(`^${resource}:(write|create|update|delete|read)$`).test(scp));
        }
        return adminScopes.includes(scope);
    });
}
